module.exports = __webpack_public_path__ + "assets/15ba56974a175d8cd0b2d47b47c01b0e.png";